module.exports = __webpack_public_path__ + "static/media/fire-station-icon.2328d608.svg";